import { InsuredPerson } from '@app/domain/model/eshop/personal-accidents/InsuredPerson';
import { PersonalInsuranceRiskPackage } from '@app/domain/model/eshop/personal-accidents/PersonalInsuranceRiskPackage';
import { DiscountCodeData } from '@app/domain/model/eshop/transport/DiscountCodeData';
import { FormState } from '@app/lib/form/contracts/FormState';
import {
    purchasePersonalAccidentsInsurance,
    PurchasePersonalInsuranceResult,
} from '@app/service/eshop/personal-accidents/actions/purchasePersonalAccidentsInsurance';
import { PersonalAccidentsInsuranceRequestResult } from '@app/service/eshop/personal-accidents/actions/requestPersonalAccidentsInsurance';

export function createEnhancedFormAction(
    discountCodeData: DiscountCodeData,
    insuredPersons: InsuredPerson[],
    requestResult: Nullable<PersonalAccidentsInsuranceRequestResult>,
    selectedRisk?: PersonalInsuranceRiskPackage,
    isReinitializedSession?: boolean,
) {
    return async (prevState: FormState<PurchasePersonalInsuranceResult>, formData: FormData) => {
        if (discountCodeData.validTravelCode) {
            formData.append('discountCode', discountCodeData.validTravelCode);
        }

        if (selectedRisk) {
            formData.append('selectedRisk', JSON.stringify(selectedRisk));
        }

        formData.append('insuredPersons', JSON.stringify(insuredPersons));

        return purchasePersonalAccidentsInsurance(prevState, formData, requestResult, isReinitializedSession);
    };
}
